import React from "react";

import { map, get } from "utils/lodash";
import Link from "components/common/Link";
import { CATEGORIES } from "utils/constant";

const Comp = ({ categories }: { categories: any[] }) => {
  return (
    <div className="bg-white ">
      <div className="container mx-auto p-6">
        <div className="flex flex-wrap gap-6 items-between justify-center">
          {map(categories, (value, index) => {
            const cat: any = CATEGORIES.filter(
              (cat) => cat.code === value.code,
            )[0];
            cat.id = value.id;
            return (
              <Link
                href={`/search?category=${get(cat, "code")}`}
                key={`cat_${index}`}
                className="flex flex-col items-center min-w-[120px]"
              >
                <div className="w-[62px] h-[62px] rounded-md bg-gray-100 flex items-center justify-center mb-2">
                  {get(cat, "icon")}
                </div>
                <span className="text-sm text-center text-gray-800">
                  {get(cat, "name")}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Comp;
